export interface LayoutConfig {
  relative?: boolean;
  color?: {
    primary: string;
  };
}

export interface LayoutNavItem extends LayoutNavItemBase {
  opened?: boolean;
  icon?: string;
  icon_mode?: string;
  items?: Array<LayoutNavItemBase | LayoutNavItemDivider>;
}

export interface LayoutNavItemBase {
  label: string;
  divider?: false;
  url?: string;
  action?: Function;
}

export interface LayoutNavItemDivider {
  divider: true;
}

export interface LayoutHeaderAction {
  icon: string;
  items: Array<LayoutNavItem | LayoutNavItemDivider>;
}
